import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import uniq from 'utils/uniq';
import { useShareContent } from 'actions/content';
import Panel from 'components/Panel';
import Stack from 'components/Stack';
import Alert from 'components/Alert';
import CheckboxOption from 'components/CheckboxOption';
import { DefaultFormFieldLayout } from 'components/FormField';
import Hint from 'components/Hint';
import { fetchUserTeams } from './utils/fetchUserTeams';
import fetchUserCount from './utils/fetchUserCount';
import { parseUserSearch } from './utils/parseUserSearchInput';
import getShareRefIds from '../shared/getShareRefIds';
import { useShareForm } from '../shared/useShareForm';
import CollapsableMessageForm from '../shared/CollapsableMessageForm';
import SendButtonPanel from '../shared/SendButtonPanel';
import ShareWithTeamsWidget from './ShareWithTeamsWidget';
import ShareWithUsersWidget from './ShareWithUsersWidget';
import ShareWithEveryoneWidget from './ShareWithEveryoneWidget';
import ConfirmationModal from './ConfirmationModal';
function calculateDifferingPermissions(data) {
  var _contentPermissions$m;
  var contentPermissions = data.contentPermissions;
  var hasSameAudience = contentPermissions === null || contentPermissions === void 0 ? void 0 : contentPermissions.every(function (content) {
    return content.audienceType === contentPermissions[0].audienceType;
  });
  var isTeamsAudience = contentPermissions === null || contentPermissions === void 0 ? void 0 : contentPermissions.every(function (content) {
    return content.audienceType === 'teams';
  });
  var sortIdsForCompare = function sortIdsForCompare(content) {
    return JSON.stringify(content.teamIds.sort());
  };
  var isSameTeams = (_contentPermissions$m = contentPermissions === null || contentPermissions === void 0 ? void 0 : contentPermissions.map(sortIdsForCompare).every(function (content, _, sortedIds) {
    return content === sortedIds[0];
  })) !== null && _contentPermissions$m !== void 0 ? _contentPermissions$m : false;
  return !hasSameAudience || isTeamsAudience && !isSameTeams;
}
function ShareEditor(_ref) {
  var _teamsToInclude$;
  var _ref$shareType = _ref.shareType,
    shareType = _ref$shareType === void 0 ? 'users' : _ref$shareType,
    data = _ref.data,
    defaultMessage = _ref.defaultMessage,
    defaultSubject = _ref.defaultSubject,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useShareContent = useShareContent(),
    shareContent = _useShareContent.shareContent;
  var teamShare = shareType === 'teams';
  var everyoneShare = shareType === 'everyone';
  var userShare = !teamShare && !everyoneShare;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    pending = _useState2[0],
    setPending = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    shareObj = _useState4[0],
    setShareObj = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    uniqueUsers = _useState6[0],
    setUniqueUsers = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showConfirmationModal = _useState8[0],
    setShowConfirmationModal = _useState8[1];
  var _useState9 = useState([[]]),
    _useState10 = _slicedToArray(_useState9, 2),
    teamsToInclude = _useState10[0],
    setTeamsToInclude = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    teamsToExclude = _useState12[0],
    setTeamsToExclude = _useState12[1];
  var _useShareForm = useShareForm({
      defaultMessage: defaultMessage,
      defaultSubject: defaultSubject
    }),
    fields = _useShareForm.fields;
  var recipients = fields.recipients,
    message = fields.message,
    subject = fields.subject,
    sendEmail = fields.sendEmail,
    searchQuery = fields.searchQuery;
  var overallContentAudienceType = data.overallContentAudienceType;
  var hasDifferingPermissions = calculateDifferingPermissions(data);
  function constructShare(finalRecipients, shareData) {
    return _objectSpread({
      teamShare: teamShare || everyoneShare,
      // We still consider everyone as a team share for the backend
      user_ids: finalRecipients.filter(function (item) {
        return item.icon === 'user' || item.type === 'user';
      }).map(function (item) {
        return item.id;
      }),
      team_ids: finalRecipients.filter(function (item) {
        return item.icon === 'team';
      }).map(function (item) {
        return item.id;
      }).filter(function (v, i, s) {
        return s.indexOf(v) === i;
      }),
      label: JSON.stringify({
        teamsToInclude: teamsToInclude,
        teamsToExclude: teamsToExclude
      }),
      sendEmail: sendEmail.value,
      subject: subject.changedValue,
      message: message.changedValue
    }, shareData);
  }
  function requestSubmit(_x) {
    return _requestSubmit.apply(this, arguments);
  }
  function _requestSubmit() {
    _requestSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var finalRecipients, searchTerms, _overallContentAudienceType, contentPermissions, search, count, _getShareRefIds, share_ref_ids, share_context_ids, _shareObj, usersFromGroups, _uniqueUsers;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            e.stopPropagation();

            // Mark the state as pending...
            setPending(true);
            finalRecipients = [];
            searchTerms = [];
            if (!(!teamShare && !everyoneShare)) {
              _context.next = 9;
              break;
            }
            finalRecipients = recipients.value;
            _context.next = 19;
            break;
          case 9:
            // search for users based on team arithmetic defined by search
            if (teamsToInclude.length) {
              teamsToInclude.forEach(function (grouping) {
                if (grouping.length) {
                  searchTerms.push("team_id:".concat(grouping.map(function (t) {
                    return t.id;
                  }).join(',')));
                }
              });
            }
            if (teamsToExclude.length) {
              searchTerms.push("-team_id:".concat(teamsToExclude.map(function (t) {
                return t.id;
              }).join(',')));
            }
            // add the content permissions into the search
            _overallContentAudienceType = data.overallContentAudienceType, contentPermissions = data.contentPermissions;
            if (_overallContentAudienceType === 'teams') {
              contentPermissions === null || contentPermissions === void 0 ? void 0 : contentPermissions.filter(function (content) {
                return content.audienceType === 'teams';
              }).forEach(function (content) {
                searchTerms.push("team_id:".concat(content.teamIds));
              });
            }
            search = searchTerms.join(' ');
            _context.next = 16;
            return fetchUserCount({
              search: search
            });
          case 16:
            count = _context.sent;
            setUniqueUsers(count);
            searchQuery.set(parseUserSearch(search));
          case 19:
            _getShareRefIds = getShareRefIds({
              type: data.type,
              playlistIds: data.playlistIds,
              assetIds: data.assetIds
            }), share_ref_ids = _getShareRefIds.share_ref_ids, share_context_ids = _getShareRefIds.share_context_ids;
            _shareObj = constructShare(finalRecipients, {
              share_ref_ids: share_ref_ids,
              share_context_ids: share_context_ids
            });
            if (!(!teamShare && !everyoneShare)) {
              _context.next = 27;
              break;
            }
            _context.next = 24;
            return fetchUserTeams(_shareObj.team_ids);
          case 24:
            usersFromGroups = _context.sent;
            _uniqueUsers = uniq([].concat(_toConsumableArray(usersFromGroups.items.map(function (u) {
              return u.user_id;
            })), _toConsumableArray(_shareObj.user_ids))).length;
            setUniqueUsers(_uniqueUsers);
          case 27:
            // share object ready
            setShareObj(_shareObj);
            setShowConfirmationModal(true);
          case 29:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _requestSubmit.apply(this, arguments);
  }
  function confirmSubmit() {
    return _confirmSubmit.apply(this, arguments);
  }
  function _confirmSubmit() {
    _confirmSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            onClose();
            payload = shareObj; // Do we have a query saved for confirmation to execute? If so, do it.
            if (searchQuery.value !== '') {
              payload.searchQuery = searchQuery.value;
              payload.limit = uniqueUsers;
            }
            _context2.next = 6;
            return shareContent(payload);
          case 6:
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            setPending(false);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return _confirmSubmit.apply(this, arguments);
  }
  var isTeamShareWithoutTeams = (((_teamsToInclude$ = teamsToInclude[0]) === null || _teamsToInclude$ === void 0 ? void 0 : _teamsToInclude$.length) === 0 || (teamsToInclude === null || teamsToInclude === void 0 ? void 0 : teamsToInclude.length) === 0) && (teamsToExclude === null || teamsToExclude === void 0 ? void 0 : teamsToExclude.length) === 0 && teamShare;
  return /*#__PURE__*/React.createElement(Panel, {
    flush: true,
    as: "form",
    onSubmit: requestSubmit
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: false
  }, hasDifferingPermissions && /*#__PURE__*/React.createElement(Panel, {
    flush: "top"
  }, /*#__PURE__*/React.createElement(Alert, null, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "modal_share_content_permission_info"
  }, "The selected content has differing access permissions. It will only be shared with people who have access to ", /*#__PURE__*/React.createElement("strong", null, "all"), " of the content."))), /*#__PURE__*/React.createElement(Panel, {
    flush: hasDifferingPermissions ? undefined : 'top'
  }, teamShare && /*#__PURE__*/React.createElement(ShareWithTeamsWidget, {
    disabled: pending || overallContentAudienceType === 'admin',
    teamsToInclude: teamsToInclude,
    teamsToExclude: teamsToExclude,
    onChangeTeamsToInclude: setTeamsToInclude,
    onChangeTeamsToExclude: setTeamsToExclude
  }), everyoneShare && /*#__PURE__*/React.createElement(ShareWithEveryoneWidget, null), userShare && /*#__PURE__*/React.createElement(ShareWithUsersWidget, {
    data: data,
    recipients: recipients.value,
    onChangeRecipients: function onChangeRecipients(newRecipients) {
      return recipients.set(newRecipients);
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    spacing: "s",
    mt: "m"
  }, /*#__PURE__*/React.createElement(CheckboxOption, {
    fontSize: "s",
    id: "sendEmailOption",
    label: t('actions_send_email'),
    checked: sendEmail.value,
    onChange: function onChange() {
      return sendEmail.set(function (prevValue) {
        return !prevValue;
      });
    }
  }), /*#__PURE__*/React.createElement(CollapsableMessageForm, {
    subject: subject,
    message: message,
    handleSubmit: requestSubmit
  }))), /*#__PURE__*/React.createElement(SendButtonPanel, {
    isDisabled: pending || !!message.error || !!subject.error || recipients.value.length === 0 && userShare || isTeamShareWithoutTeams
  }), isTeamShareWithoutTeams && /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Hint, null, t('share_hint_select_teams'))), showConfirmationModal && /*#__PURE__*/React.createElement(ConfirmationModal, {
    uniqueUsers: uniqueUsers,
    data: data,
    onCancel: function onCancel() {
      setPending(false);
      setShowConfirmationModal(false);
    },
    onConfirm: confirmSubmit
  })));
}
export default ShareEditor;